import ButtonPrimary from '../../ButtonPrimary'

const ButtonPrimaryGhost = ({
  title,
  disabled = false,
  loading = false,
  onClick = () => {},
  ...props
}) => {
  return (
    <ButtonPrimary
      {...props}
      ghost
      title={title}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    />
  )
}

export default ButtonPrimaryGhost
